import { render, staticRenderFns } from "./TechTalentCard.vue?vue&type=template&id=618fbc26&scoped=true"
import script from "./TechTalentCard.vue?vue&type=script&lang=js"
export * from "./TechTalentCard.vue?vue&type=script&lang=js"
import style0 from "./TechTalentCard.vue?vue&type=style&index=0&id=618fbc26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618fbc26",
  null
  
)

export default component.exports